// extracted by mini-css-extract-plugin
export default {"notificationContainer":"ParentNotification_notificationContainer__z4hpu","notificationIcon":"ParentNotification_notificationIcon__Q6EGO"};